import { useState } from 'react';
import { observer } from 'mobx-react';
import { henshu } from '../../../../henshu';

import Section from '../Section';
import content from '../../store';
import xIcon from '../../assets/x-icon.svg';


const PHASES = [1, 2, 4, 3].map(n => `Process.phase${n}`);


export default observer(function Process() {
    const { instance: store } = content;
    const [phase, setPhase] = useState(PHASES[0]);

    return (
        <Section anchor={store.menu[2]} name="Process">
            <henshu.p
                getter={() => store.term('Process.body')}
                setter={t => store.setTerm('Process.body', t)}
            />

            <div className="timeline">
                {PHASES.map(_phase => (
                    <div key={_phase} className={`block ${_phase === phase ? 'active' : ''}`} onClick={() => setPhase(_phase)}>
                        <p>
                            <henshu.span
                                getter={() => store.term(`${_phase}.name`)}
                                setter={t => store.setTerm(`${_phase}.name`, t)}
                            />
                            <henshu.span
                                className='will-hide'
                                getter={() => store.term(`${_phase}.duration`)}
                                setter={t => store.setTerm(`${_phase}.duration`, t)}
                            />
                        </p>

                        <henshu.span
                            className="will-hide"
                            getter={() => store.term(`${_phase}.title`)}
                            setter={t => store.setTerm(`${_phase}.title`, t)}
                        />
                    </div>
                ))}
            </div>

            <ul className="phases">
                {PHASES.map((_phase, i) => (
                    <li
                        key={_phase}
                        onClick={() => setPhase(_phase)}
                        className={_phase === phase ? 'active' : ''}
                    >
                        <header>
                            <button className="unstyled" onClick={e => { e.stopPropagation(); _phase === phase ? setPhase(null) : setPhase(_phase); }}>
                                <img src={xIcon} alt="Close phase" />
                            </button>

                            <henshu.span
                                getter={() => store.term(`${_phase}.duration`)}
                                setter={t => store.setTerm(`${_phase}.duration`, t)}
                            />

                            <h4>
                                Phase 0{i+1}:&nbsp;
                                <henshu.span
                                    getter={() => store.term(`${_phase}.title`)}
                                    setter={t => store.setTerm(`${_phase}.title`, t)}
                                />
                            </h4>
                        </header>

                        <henshu.richtext
                            getter={() => store.term(`${_phase}.body`)}
                            setter={t => store.setTerm(`${_phase}.body`, t)}
                        />
                    </li>
                ))}
            </ul>
        </Section>
    );
});
